// extracted by mini-css-extract-plugin
export default {"showSinglePostContainer":"ShowSinglePost_showSinglePostContainer__xAmfc","quill":"ShowSinglePost_quill__pwroe"};